import KnowledgeBaseBackground from "./KnowledgeBaseBackground";

export default KnowledgeBaseBackground;
